import { Button, Flex, Heading } from "@aws-amplify/ui-react";
import { useNavigate } from "react-router-dom";
import ImagingAndLabsContainer from "./ImagingAndLabsContainer";
export default function ImagingAndLabsPage() {
  const navigate = useNavigate();

  return (
    <Flex
      direction="column"
      padding="32px 32px 32px 32px"
      backgroundColor="rgba(250,250,250,1)"
    >
      <Flex direction="row" alignItems="center">
        <Heading level="1" children="Imaging and Labs Results"></Heading>
        <Button
          size="small"
          variation="primary"
          onClick={() => navigate(`/user/hr/documents/add`)}
        >
          Add
        </Button>
      </Flex>
      <ImagingAndLabsContainer />
    </Flex>
  );
}
